import { Formik } from 'formik';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Button, Link, TextField } from '@material-ui/core';
import { useLogin } from '@sierralabs/user-ui';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
import * as Styled from './Login.styled';
import SiteConfigLogin from './SiteConfigLogin';
const loginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email address.')
        .required('Email address is required.'),
    password: Yup.string().required('Password is required.')
});
export const SiteLogin = props => {
    const history = useHistory();
    const component = useSubscribeComponentChanges(SiteLoginPlugin, props);
    const { title, buttonText, textLink, path } = component.props || {};
    const classes = ['site-login'];
    const { editing, editorPath, isHover, hoverProps } = useSiteContext();
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const { user, isLoading, error, doLogin } = useLogin();
    const errorMessage = error
        ? error.statusCode === 409
            ? 'Email verification required. Please check your email.'
            : 'Login failed. Please double check your credentials.'
        : undefined;
    useEffect(() => {
        if (user && history.location.pathname.indexOf(editorPath) === 0) {
            return history.push(editorPath);
        }
        else if (user && !editing) {
            return history.push(path || '/');
        }
    }, [history, user, editing, path, editorPath]);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteLoginPlugin }, props),
        React.createElement(Styled.StyledLoginContainer, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            React.createElement(Styled.StyledLoginCard, null,
                React.createElement("img", { src: '/assets/sl-logo@2x.png', alt: 'Sierra Labs', className: 'logo' }),
                React.createElement("h2", null, title ? title : 'Log In'),
                React.createElement(Formik, { initialValues: { email: '', password: '' }, validationSchema: loginSchema, validateOnBlur: true, onSubmit: form => doLogin(form.email, form.password) }, ({ values, errors, touched, handleChange, handleBlur }) => (React.createElement(Styled.StyledLoginForm, null,
                    React.createElement(TextField, { variant: 'outlined', type: 'email', name: 'email', label: 'Email', className: 'form-field', onChange: handleChange, onBlur: handleBlur, value: values.email, error: touched.email && !!errors.email, helperText: errors.email }),
                    React.createElement(TextField, { variant: 'outlined', type: 'password', name: 'password', label: 'Password', className: 'form-field', onChange: handleChange, onBlur: handleBlur, value: values.password, error: touched.password && !!errors.password, helperText: errors.password }),
                    !isLoading && error && (React.createElement("p", { className: 'error' }, errorMessage)),
                    React.createElement(Button, { variant: 'contained', color: 'primary', disableElevation: true, type: 'submit', disabled: isLoading }, buttonText ? buttonText : 'Login')))),
                React.createElement(Link, { className: 'forgot-password-link' }, textLink ? textLink : 'Forgot Password')))));
};
export const SiteLoginPlugin = {
    name: 'Site Login',
    type: 'site-login',
    component: SiteLogin,
    configurator: SiteConfigLogin,
    initConfig: component => {
        if (!component.props)
            component.props = {};
        component.props.title = 'Log In';
        component.props.buttonText = 'Login Button Label';
        component.props.textLink = 'Forgot Password Link Label';
        return component;
    }
};
//# sourceMappingURL=SiteLoginPlugin.js.map